import { render, staticRenderFns } from "./PremiumMembership.vue?vue&type=template&id=5b70244a&scoped=true"
import script from "./PremiumMembership.vue?vue&type=script&lang=js"
export * from "./PremiumMembership.vue?vue&type=script&lang=js"
import style0 from "./PremiumMembership.vue?vue&type=style&index=0&id=5b70244a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70244a",
  null
  
)

export default component.exports